<script>
    import debounce from 'lodash/debounce';
    import axios from "axios";
    import {SpinnerMixin} from "../mixins/SpinnerMixin";

    export default {
        name: "Registration",
        mixins: [SpinnerMixin],
        props: {
            account_type_init: {
                default: null
            },
            entity_type_init: {
                default: null
            },
            phone_select_initial: {
                default: ""
            },
            fupa_countries: {
                type: Array,
                default: []
            },
            // is_ios_initial: {
            //     default: true
            // },
            is_social: {
                default: false
            },
            invite_init: {
                default: null
            },
        },
        data() {
            return {
                // is_ios: this.is_ios_initial,
                account_type: this.account_type_init,
                entity_type: this.entity_type_init,
                is_invited: false,
                create_account: true,
                account_to_join: null,
                phone_select: this.phone_select_initial,
                invite: this.invite_init
            }
        },
        methods: {
            fetchByEmail: debounce(function ({target}) {
                this.loading = true;
                let url = this.$store.state.global_data.urls['api:invite-exists']();
                axios.get(
                    url, {
                        params: {
                            email: target.value
                        }
                    }
                ).then((response) => {
                    this.is_invited = response.data.exists;
                    this.create_account = !response.data.exists;
                    this.loading = false;
                    this.invite = response.data.invite
                }).catch((error) => {
                    this.loading = false;
                })
            }, 300),
        },
        mounted() {
            this.loading = false;
            if (!this.is_social)
                this.fetchByEmail({target: this.$refs.emailinput});
            let inputs = document.getElementsByClassName('el-input__inner')
            for(let i = 0;i < inputs.length; i++){
              inputs[i].addEventListener("click", function sendGaEvent(event) {
              if (window.hasOwnProperty('gtag')) {
                window.gtag('event', 'click_'+inputs[i].name,
                  {
                      device: window.navigator.userAgent
                  });
                }
            })
              inputs[i].addEventListener("change", function sendGaEvent(event) {
              if (window.hasOwnProperty('gtag')) {
                window.gtag('event', 'fill_'+inputs[i].name,
                  {
                      device: window.navigator.userAgent
                  });
                }
            })
            }
            document.getElementById('submit_form').addEventListener("click", function sendGaEvent(event) {
              if (window.hasOwnProperty('gtag')) {
                window.gtag('event', '1st_form_submit',
                  {
                      device: window.navigator.userAgent
                  });
                }
            })
        }
    }
</script>